export class CardFuncContainer {
  constructor(cardFuncEnum, cardFunc, cardDiffFunc) {
    this.cardFuncEnum = cardFuncEnum;

    this.cardFunc = cardFunc;

    this.cardDiffFunc = cardDiffFunc;
  }
}